<script>
  // Client-side toast for review actions that run over JSON fetch (no redirect,
  // so no server flash). Mirrors flash_message.svelte's look.
  //
  //   <ActionToast {toast} ondismiss={() => (toast = null)} />
  //
  // `toast`: { type: 'success' | 'error' | 'warning', title, text?, persistent? }
  // Auto-dismisses after 5s unless `persistent`.
  import Button from '../ui/button.svelte'

  let { toast = null, ondismiss = () => {} } = $props()

  const ALERT_CLASSES = { success: 'alert-success', error: 'alert-error', warning: 'alert-warning' }

  $effect(() => {
    if (!toast || toast.persistent) return
    const timeoutId = setTimeout(ondismiss, 5000)
    return () => clearTimeout(timeoutId)
  })
</script>

{#if toast}
  <div class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
    <div class="alert {ALERT_CLASSES[toast.type] || ALERT_CLASSES.error} shadow max-w-md items-start" role="alert">
      <div class="text-sm">
        <p class={toast.text ? 'font-semibold' : ''}>{toast.title}</p>
        {#if toast.text}<p class="whitespace-pre-line mt-1">{toast.text}</p>{/if}
      </div>
      <Button variant="ghost" size="sm" circle icon="close" class="ml-auto" aria-label="Dismiss" onclick={ondismiss} />
    </div>
  </div>
{/if}
